<template>
  <v-btn text x-small color="primary" @click="onClick">{{ $t("bookingForm.BookingBackButton.editButton") }}</v-btn>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class BookingBackButton extends Vue {
  onClick() {
    this.$emit("click");
  }
}
</script>
